<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Abteilung</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">

    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <div class="form-floating">
            <input type="text" class="form-control" id="name" [(ngModel)]="Name">
            <label for="name">Name</label>
          </div>
        </div>
      </div>
    </div>

  <div class="EditBtnRow row">
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn btn-primary" (click)="Send()">Speichern</div>
    </div>
  </div>
</div>
